export const MAX_WIDTH_SMALL_LOGIN = 767;
export const MAX_WIDTH_SMALL_SCREEN = 500;
export const DEFAULT_REDIRECT_ROUTE = '/home';
export const HOMEPAGE_REDIRECT_ROUTE = 'https://dealmakers24.com';
export const COPY_MESSAGE = 'Copied to clipboard';
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_IMG = 'https://dg53pzd6emty4.cloudfront.net/business';
export const BASE_IMG_PROFILES = 'https://dg53pzd6emty4.cloudfront.net/profiles';

export const LOGO_MAIN = `${BASE_IMG}/deals.svg`;
export const LOGO_TEXT = `${BASE_IMG}/deals_text.png`;
export const LOGO_LOGIN_MAIN = `${BASE_IMG}/deals_logo.svg`;
export const LOGO_LOGIN_TEXT = '';

export const BRAND_NAME = 'Dealmakers24';
export const BRAND_TAGLINE = 'Connecting Corporate Buyers with Trusted Sellers';

export const FRONTEND_URL = 'https://dealmakers24.com';
export const ENTERPRISE_URL = 'https://buyers.dealmakers24.com';
export const MAX_FIELD_PER_ROW = 4;

export const AUTHS_ALLOWED = ['google', 'local'];

export const NAVBAR_ITEMS = [
  { label: 'About Us', route: '/about', className: 'Link hover1', liClassName: '' },
  { label: 'FAQs', route: '/faqs', className: 'Link hover1', liClassName: '' },
  { label: 'Careers', route: '/careers', className: 'Link hover1', liClassName: '' },
  { label: 'Contact Us', route: '/contact', showWhenSettings: false, className: 'Link color_contact', liClassName: 'color_contact' },
];

export const NAVBAR_ITEMS_RAZE = [
  { label: 'Products', route: '/products', className: 'Link hover1', liClassName: '' },
  { label: 'Pricing', route: '/pricing', className: 'Link hover1', liClassName: '' },
  { label: 'Team', route: '/team', className: 'Link hover1', liClassName: '' },
  { label: 'Blogs', route: '/blogs', className: 'Link hover1', liClassName: '' },
  { label: 'Schedule a demo', route: '#contact?scroll=scroll-top', onClick: 'scroll-top', showWhenSettings: false, className: 'Link color_contact', liClassName: 'color_contact' },
];

export const COMPONENT_ROUTE_MAP = {
    DashboardOverall: 'dashboard-overall',
    DashboardDeals: 'dashboard-deals',
    VendorOnboard: 'vendor-add',
    VendorLists: 'vendor-list',
    VendorProfile: 'vendor-profile',
    VendorRank: 'vendor-rank',
    VendorDiscover: 'vendor-discover',
    VendorExplore: 'vendor-explore',
    AccountInfo: 'account-info',
    VendorSubscriptionPlans: 'subscription-vendor',
    VendorQuotations: 'quotations',
    Vendors: 'vendors',
    VendorApprovals: 'vendor-approvals',
    VendorTasks: 'vendor-tasks',
    EnterpriseData: 'enterprise-data',
    ProfileEdit: 'edit-profile',
    ProductSKU: 'product-sku',
}
export const PROFILE_CTA_MAP = {
    VERIFIED_VENDOR: 'Vendor has completed the verification process, all the following info is marked as correct',
    NOT_VERIFIED_VENDOR: "Verification is pending from Vendor's end"
}
export const ACCOUNT_CTA_MAP = {
     ACCOUNT_VERIFICATION: 'Important: Some account information has been sourced in advance from different partners, please verify and make rectifications wherever required',
}

export const ERROR_CTA_MAP = {
    FILE_UPLOAD_ERROR: 'File upload failed. Please try again.',
    FILE_TYPE_ERROR: 'This file type is not supported.'
}
export const COMPONENT_DISPLAY_TEXT = {
    PROFILE_BREADCRUMB: 'Vendor Profile'
}
export const ONBOARDING_COMPLETED_STATUS = 'onboarding-completed'
export const CREATION_COMPLETED_STATUS = 'creation-completed'

export const LINK_URL_NOTES             = 'notes-vendor'
export const LINK_URL_PAYWALL           = 'pricing-enterprise'
export const LINK_URL_QUOTES            = 'quotes-vendor'
export const LINK_TYPE_MODAL            = 'modal'
export const LINK_EDIT_DETAILS          = 'edit-details'
export const LINK_ATTACHMENTS           = 'attachment-vendor'
export const LINK_EMAIL_VERIFICATION    = 'verify-vendor'
export const LINK_URL_VENDOR_PROFILE    = 'vendor-profile'
export const LINK_TYPE_ROUTE_INTERNAL   = 'internal'
export const LINK_API_CALL              = 'api'

export const MODAL_TITLES = {
    note: {
        ADD: 'Add a note',
        EDIT: 'Edit a note',
        DELETE: 'Delete a note'
    }
}

export const SPIN_TEXT_MAP = {
    VENDOR_RESGISTRATION_SUCCESS: 'Vendor successfully added',
    VENDOR_RESGISTRATION_ERROR: 'Something went wrong, Please try again'
}

export const LINK_SEPERATOR = '\n Link:- \n';
/* eslint-disable no-useless-escape */
export const LINK_REGEX = /((?:(?:https?|ftp):\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s]*)?)/gi;

export const FILTER_OPTIONS = {
    column: [
        { value: 'sinkPartnerName', label: 'Name' },
        { value: 'category', label: 'Category' },
        { value: 'status', label: 'Status' },
        { value: 'state', label: 'State' },
        {value : 'entityType', label: 'Entity Type'},
        {value: 'universal_id', label: 'Application ID'}
    ],
    operator: [
        { value: 'eq', label: '=' },
        { value: 'neq', label: '!=' },
        { value: 'in', label: 'in' },
        { value: 'nin', label: 'not in' },
    ],
    category: [],
    entityType: [],
    status: [
      { value: 'started', label: 'Started' },
      { value: 'pending', label: 'Pending' },
      { value: 'completed', label: 'Completed' },
    ],
    state: [
      { value: 'creation', label: 'Creation' },
      { value: 'invitation', label: 'Invitation' },
      { value: 'verification', label: 'Verification' },
      { value: 'onboarding', label: 'Onboarding' },
    ],
};

export const DEFAULT_TAB = "2"

export const TAB_CONFIG_MAP = {
    "1": {
        actionedBy: 'approver',
        approvalType: 'ListApprovals',
        filterBy: 'finalStatus-in-pending'
    },
    "2": {
        actionedBy: 'requester',
        approvalType: 'ListApprovalsAdmin',
        filterBy: ''
    },
    "3": {
        actionedBy: 'approver',
        approvalType: 'ListApprovals',
        filterBy: 'finalStatus-in-rejected,approved'
    }
}

export const QUOTE_STATUS_FILTER_OPTIONS = [
    { value: 'pending', label: 'Pending' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'InActive' },
    { value: 'completed', label: 'Completed' },
];

export const MARKET_DEFAULT_TAB = "1"

export const MARKET_TAB_CONFIG_MAP = {
    "1": {
        dealStatus: 'live',
        dealsType: 'LiveDeals',
        filterBy: 'status-in-pending,active'
    },
    "2": {
        dealStatus: 'closed',
        dealsType: 'ClosedDeals',
        filterBy: 'status-in-completed,rejected,inactive'
    }
}
